import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';

const Loader = () => {
    return (
        <Box
            className="min-h-screen min-w-full flex items-center justify-center"
            sx={{
                backgroundColor: 'background.default',
            }}
        >
            <CircularProgress />
        </Box>
    );
};

export default Loader;
